import PropTypes from "prop-types";
import { Button, Card } from "react-bootstrap";
import { FaChild } from "react-icons/fa";


const CardWithButton = ({
  title,
  buttonLabel,
  buttonIcon,
  buttonClick,
  variant = "info",
  size = "md",
  className = "",
  type = "button",
  buttonLabelTwo,
  buttonClickTwo,
  classNames,
  isBlogActive = false,
}) => {
  return (

    <Card className="shadow-lg rounded-md p-2 text-center bg-light mt-4 ms-5 me-5 border-0">
      <Card.Body className="d-flex justify-content-around align-content-center">
        <Card.Title className="fw-bold fs-5 text-info mt-2">{title}</Card.Title>
        <div className="d-flex gap-5">
          <Button
            type={type}
            onClick={buttonClick}
            variant={variant}
            size={size}
            className={`d-flex align-items-center gap-2 fw-semibold justify-content-center text-white ${!isBlogActive ? "bg-info" : "bg-secondary"
              }`}
          >
            {
              !isBlogActive && <span style={{color:"red"}}>
                <FaChild />
              </span>
            }

            {buttonIcon && <span >{buttonIcon}</span>}
            <span className="">{buttonLabel}</span>
          </Button>
          {
            buttonLabelTwo && (
              <Button
                type={type}
                onClick={buttonClickTwo}
                variant={variant}
                size={size}
                className={`d-flex align-items-center gap-2 fw-semibold justify-content-center text-white ${isBlogActive ? "bg-info" : "bg-secondary"
                  }`}
              >
                {
                  isBlogActive && <span style={{color:"red"}}>
                    <FaChild />
                  </span>
                }
                {buttonIcon && <span >{buttonIcon}</span>}
                <span className="">{buttonLabelTwo}</span>
              </Button>
            )
          }
        </div>
      </Card.Body>
    </Card>
  );
};

CardWithButton.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  buttonLabel: PropTypes.string.isRequired,
  buttonIcon: PropTypes.element,
  buttonClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
};

export default CardWithButton;
